import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../config/firebase";

// Note: Firestore collection name remains `adhkar_chapters` for backwards compatibility.
export const loadDhikrChapters = async () => {
  try {
    const chaptersQuery = query(
      collection(db, "adhkar_chapters"),
      orderBy("order", "asc")
    );
    const snapshot = await getDocs(chaptersQuery);
    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Error loading dhikr chapters:", error);
    throw error;
  }
};
